import NmotRoute from './NmotRoute'

const routes = [new NmotRoute()]

export default routes
